import React from 'react'
import ItemTileCover from '../itemTile/ItemTileCover'
import ItemTileInformation from '../itemTile/ItemTileInformation'
import withItemTileHover from '../itemTile/withItemTileHover'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import SimpleFormat from '../simpleFormatter/SimpleFormatter'
import FavoritePlusButton from '../favoriteButton/FavoritePlusButton'
import IntroductoryIcon from '../../../assets/codicons/introductory'
import BeginnerIcon from '../../../assets/codicons/beginner'
import ModerateIcon from '../../../assets/codicons/moderate'
import IntermediateIcon from '../../../assets/codicons/intermediate'
import AdvancedIcon from '../../../assets/codicons/advanced'

const PlanEntryTileItem = (props) => {
  const planEntry = props.planEntry

  let title = planEntry.classFinderTitle
    ? planEntry.classFinderTitle
    : planEntry.title

  const planEntryTileClasses = classNames(
    'product-card',
    'product-tile',
    'single-class-container',
    {
      'has-description': props.hasDescription,
      list: props.inListLayout,
      tile: props.inTileLayout
    }
  )

  let card = React.createRef()
  let itemToReveal = React.createRef()

  let tileDescription
  if (props.hasDescription && props.inListLayout) {
    tileDescription = (
      <div className='product-description' ref={itemToReveal}>
        <SimpleFormat text={planEntry.previewDescription} />
      </div>
    )
  }

  const renderDifficultyIcon = (difficulty) => {
    switch (difficulty) {
      case 'introductory':
        return <IntroductoryIcon />
      case 'beginner':
        return <BeginnerIcon />
      case 'moderate':
        return <ModerateIcon />
      case 'intermediate':
        return <IntermediateIcon />
      case 'advanced':
        return <AdvancedIcon />
    }
  }

  let parentLabel
  if (
    !planEntry.plan.category ||
    planEntry.plan.category.slug !== 'single-classes'
  ) {
    parentLabel = (
      <span className='product-plan'>
        Part Of
        <a href={planEntry.planProduct.url()}> {planEntry.plan.title}</a>
      </span>
    )
  }

  return (
    <div className={planEntryTileClasses} ref={card}>
      <ItemTileCover
        coverPhoto={planEntry.videoThumbnail}
        primaryCategory={planEntry.plan.category}
        itemUrl={planEntry.planEntryUrl}
        includePlayIcon
        completedIcon={() => {
          let completedPlanEntryTick
          if (planEntry.completed) {
            completedPlanEntryTick = (
              <div className='completed-container'>
                <i className='fa fa-check-completed' />
              </div>
            )
          }
          return completedPlanEntryTick
        }}
        metaDataComp={
          <div className='item-meta-data'>
            <div className='difficulty'>
              {renderDifficultyIcon(planEntry.plan.difficultyLevel)}
              <span className='full'>{planEntry.plan.difficultyLevel}</span>
              <span className='truncated'>
                {planEntry.plan.difficultyLevel
                  ? planEntry.plan.difficultyLevel.substring(0, 3)
                  : null}
              </span>
            </div>
            <div className='product-class-duration'>
              {planEntry.humanDuration}
            </div>
          </div>
        }
      />

      <div
        onTransitionEnd={props.transitionEnd}
        onMouseEnter={() => {
          props.mouseEnterAction(card.current, itemToReveal.current)
        }}
        onMouseLeave={props.mouseLeaveAction}
      >
        <ItemTileInformation
          title={title}
          product={planEntry.planProduct}
          coaches={planEntry.plan.coaches}
          itemUrl={planEntry.planEntryUrl}
          includeInstructorName={props.includeInstructorName}
          renderItemFavoriteButton={() => {
            if (props.showFavoriteButton) {
              return <FavoritePlusButton planEntry={planEntry} />
            }
          }}
          parentLabel={parentLabel}
        />
        {tileDescription}
      </div>
    </div>
  )
}

PlanEntryTileItem.defaultProps = {
  includeInstructorName: true
}

PlanEntryTileItem.propTypes = {
  hasDescription: PropTypes.bool,
  inListLayout: PropTypes.bool,
  inTileLayout: PropTypes.bool,
  includeInstructorName: PropTypes.bool,
  mouseEnterAction: PropTypes.func,
  mouseLeaveAction: PropTypes.func,
  planEntry: PropTypes.object,
  transitionEnd: PropTypes.func,
  showFavoriteButton: PropTypes.bool,
  updateFeaturedFlagInTree: PropTypes.func
}

const PlanEntryTile = (props) => {
  let HoveredPlanEntryTile = withItemTileHover(PlanEntryTileItem)
  return <HoveredPlanEntryTile {...props} />
}

export default PlanEntryTile
